import React from "react";

import Background from "../../../assets/market/market-01-select.png";
import ImageA from "../../../assets/market/market-01-option-a.png";
import ImageB from "../../../assets/market/market-01-option-b.png";

import GameSelectionLayout from "../GameSelectionLayout";

const MarketPage2 = ({ setCurrentPage, setGarbageQtty }) => {
  const handleClickA = () => {
    setGarbageQtty((prev) => prev + 20);
    setCurrentPage("market-3");
  };

  const handleClickB = () => {
    setGarbageQtty((prev) => prev + 23);
    setCurrentPage("market-4");
  };

  return (
    <GameSelectionLayout
      bg={Background}
      imageA={ImageA}
      textA="마트장보기"
      onClickA={handleClickA}
      imageB={ImageB}
      textB="인터넷주문"
      onClickB={handleClickB}
      currentIndex={4}
    >
      근처에 마트가 있으니까
      <br />
      장바구니만 챙겨서 가볼까?
      <br />
      ...
      <br />
      나가기 좀 귀찮은데.
      <br />
      그냥 배달 고..?
    </GameSelectionLayout>
  );
};

export default MarketPage2;
